function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import Action from "../../action";
import UrlUtils from "../../utils/url";
import TypeUtils from "../../utils/type";
export default {
  data: function data() {
    return {
      // TODO: Consider replacing with an enum, e.g. executing with predefined values ('post', 'get', null)
      // The complexity with this is that 'get' that comes after 'post' needs to show an indicator, e.g.
      // Submit button needs to be disabled when redirecting after form submission
      _isBusy: false,
      _events: [],
      _typingTimer: null
    };
  },
  computed: {
    _pageBody: function _pageBody() {
      return document.getElementById("page_body");
    },
    $isBusy: function $isBusy() {
      // Properties starting with $ or _ can only be accessed via $data
      return this.$data._isBusy;
    },
    $isReady: function $isReady() {
      return this.$data._events === null;
    }
  },
  created: function created() {
    this.$created();
  },
  mounted: function mounted() {
    this._executeIfReady(false);

    this.$mounted();
  },
  updated: function updated() {
    this._executeIfReady(true);

    this.$updated();
  },
  destroyed: function destroyed() {
    this.$tearDown();
  },
  watch: {
    // See Utils.http
    "$root.vueApp.isStale": function $rootVueAppIsStale(val, oldVal) {
      // Make sure $ready() will be called in the next update
      this._mountedUrl = null;
    }
  },
  methods: {
    $href: function $href(spec) {
      var properties = spec || this.spec;
      var onClick = properties.onClick;

      if (TypeUtils.isObject(onClick)) {
        switch (onClick.action) {
          case "windows/open-v1":
          case "windows/openWeb-v1":
          case "windows/reload-v1":
            return UrlUtils.htmlUrl(onClick.url);
        }
      }

      return null;
    },
    $onClick: function $onClick(explicitEvent, spec) {
      var properties = spec || this.spec;
      var e = explicitEvent || event;

      if (!properties.onClick) {
        return; // Avoid blocking the event for parents.
      } // Ignore middle/right clicks


      if (!e.metaKey && !e.ctrlKey && e.button === 0) {
        e.preventDefault();
        e.stopPropagation();
        Action.execute(properties.onClick, this);
      }
    },
    $rel: function $rel(spec) {
      var properties = spec || this.spec;
      var onClick = properties.onClick;

      if (TypeUtils.isObject(onClick)) {
        if (onClick.action === "windows/openWeb-v1") {
          return "nofollow";
        }
      }

      return null;
    },
    // Can be used for optimization, but not needed for now.
    // $onLongPressFunction() {
    //   return this.spec.onLongPress ? this.$onLongPress : null;
    // },
    $onLongPress: function $onLongPress() {
      GLib.action.execute(this.spec.onLongPress, this);
    },
    $addViewportChangeListeners: function $addViewportChangeListeners(handler) {
      window.addEventListener("load", handler);
      window.addEventListener("resize", handler);

      this._pageBody.addEventListener("scroll", handler);
    },
    $removeViewportChangeListeners: function $removeViewportChangeListeners(handler) {
      window.removeEventListener("load", handler);
      window.removeEventListener("resize", handler);

      this._pageBody.removeEventListener("scroll", handler);
    },
    _executeIfReady: function _executeIfReady(updated) {
      if (updated) {
        if (!this._renderingTheSamePage()) {
          this.$tearDown();

          this._ready();
        }
      } else {
        this._ready();
      }
    },
    _renderingTheSamePage: function _renderingTheSamePage() {
      return this._mountedUrl === window.location.href;
    },
    _ready: function _ready() {
      this._mountedUrl = window.location.href;
      this._updatedAt = new Date().getTime();
      this.$data._events = []; // Has to be executed before $ready()

      this._linkFieldModels();

      this.$ready(); // Make sure events are dispatched after $ready(). Dispatching them during $ready() causes errors.

      var _iterator = _createForOfIteratorHelper(this.$data._events),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _event = _step.value;
          this.$el.dispatchEvent(_event);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.$data._events = null;
    },
    // Order of execution:
    // Initial page load: $created() -> $ready() -> $mounted() -> $updated() (because of $ready(), may get called multiple times)
    // windows_open: $created() (only if it isn't reused) -> $ready() -> $mounted() (only if it isn't reused) -> $updated()
    // components_update: $ready() -> $updated() (because of $ready(), may get called multiple times)
    $ready: function $ready() {// To be overridden. Initialize component data here.
      // This method has to be idempotent because it might get called multiple times (due to components_update).
    },
    $created: function $created() {// To be overridden
    },
    $tearDown: function $tearDown() {// To be overridden
    },
    $mounted: function $mounted() {// To be overridden. Put one-off event listener initialization here (e.g. $onEvent()).
    },
    $updated: function $updated() {// To be overridden
    },
    $dispatchEvent: function $dispatchEvent(name, data) {
      var event = new Event(name, {
        bubbles: true
      }); // TODO: Deprecate

      event.spec = data;
      event.data = data;

      if (this.$data._events) {
        this.$data._events.push(event);
      } else {
        this.$el.dispatchEvent(event);
      }
    },
    $onEvent: function $onEvent(name, handler) {
      this.$el.addEventListener(name, handler);
    },
    $onTyping: function $onTyping(_ref) {
      var _this = this;

      var _ref$duration = _ref.duration,
          duration = _ref$duration === void 0 ? 2000 : _ref$duration;
      GLib.action.execute(this.spec.onTypeStart, this);
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this._typingTimer = null;
        GLib.action.execute(_this.spec.onTypeEnd, _this);
      }, duration);
    }
  }
};